import { render, staticRenderFns } from "./ModelAlgorithmSelector.vue?vue&type=template&id=6f94fc9c&"
import script from "./ModelAlgorithmSelector.vue?vue&type=script&lang=ts&"
export * from "./ModelAlgorithmSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports